import { Translate } from 'react-admin';

export function translateErrorMessages(error: string | string[], translate: Translate): string {
  const messages = Array.isArray(error) ? Array.from(new Set(error)) : [error];

  return messages.map(translate).join(' ');
}
